module.exports = require("./nds.d.ts");